export default "__VITE_ASSET__9ad9c98b__"